export class JqueryTransport {
	constructor(transport) {
		this._transport = transport;
		this._method = 'GET';
	}

	// TODO - output something Promises/A compatible
	fetch(url, data) {
		return this._transport({
			url: url,
			type: this._method,
			dataType: 'json',
			data: data
		});
	}

	setMethod(method) {
		this._method = method;
	}
}
